import { ThemeProvider } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import axios from 'axios';
import MaterialTable from 'material-table';
import moment from 'moment';
import { Component } from "react";
import { Badge, Button, Card, Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import JobAddModal from './JobAddModal';
import JobDeleteModal from './JobDeleteModal';
import JobEditModal from './JobEditModal';

import { hasPermission } from "../utils/usePermission";
import { DateTimeFormat } from './DateFormat/DateTimeFormat';
import CommonLoader from "./loaderComponent/CommonLoader";

export default class JobList extends Component {

  constructor(props) {
    super(props)

    this.state = {
      departments: [],
      selectedDepartment: null,
      selectedJob: null,
      jobs: [],
      showEditModel: false,
      showAddModel: false,
      showDeleteModel: false,
      loading: true,
    }
  }

  componentDidMount() {
    // this.s  this.fetchData()etState({ loading: true })
    this.setState({ loading: true }, () => {
      this.fetchData();
    });
    if (this.props.location.state) {
      this.setState({ selectedDepartment: this.props.location.state.selectedDepartment })
    }
    axios({
      method: 'get',
      url: '/departments',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        this.setState({ departments: res.data }, () => {
          if (this.state.selectedDepartment) {
            this.fetchData()
          }
        })
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      })
      .catch(err => {
        console.log(err)
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      })
  }

  fetchData = () => {
    if (!this.state.selectedDepartment) return;
    this.setState({ loading: true });
    axios({
      method: 'get',
      url: `/departments/${this.state.selectedDepartment}`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        let department = res.data
        let jobs = [];

        department.users.map(user => {
          user.jobs.map((job, index) => {
            job.startDate = moment(job.startDate).format('YYYY-MM-DD')
            job.endDate = moment(job.endDate).format('YYYY-MM-DD')
            jobs.push(job)
          })
        })

        this.setState({ jobs: jobs })
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      })
      .catch(err => {
        console.log(err)
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      })
  }

  fetchDataAll = () => {

    axios({
      method: 'get',
      url: 'departments/',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        let departments = res.data
        let jobs = [];

        departments.map(dept => {
          dept.users.map(user => {
            user.jobs.map((job, index) => {
              job.startDate = moment(job.startDate).format('YYYY-MM-DD')
              job.endDate = moment(job.endDate).format('YYYY-MM-DD')
              jobs.push(job)
            })
          })
        })
        this.setState({ jobs, loading: false });
      })
      .catch(err => {
        console.log(err)
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      })
  }

  pushSelectItems = () => {
    let items = []
    items.push(<option key={584390} value="all">All departments</option>)
    this.state.departments.map((dept, index) => {
      if (this.state.selectedDepartment === dept.id) {
        items.push(<option key={index} value={dept.id} defaultValue>{dept.departmentName}</option>)
      } else {
        items.push(<option key={index} value={dept.id} defaultValue>{dept.departmentName}</option>)
      }
    })
    return items
  }

  handleChange = (event) => {
    this.setState({ selectedDepartment: event.target.value }, () => {
      if (this.state.selectedDepartment === "all") {
        this.fetchDataAll()
      } else {
        this.fetchData()
      }
    })
  }

  onEdit(job) {
    if (!job.endDate || isNaN(new Date(job.endDate).getTime())) {
      console.error("Invalid endDate:", job.endDate);
      return;
    }

    return (event) => {
      event.preventDefault();
      // debugger;

      this.setState({ selectedJob: job, showEditModel: true });
      setTimeout(() => {
        this.setState({ loading: false });
      }, 900);
    };
  }

  addJob = () => {

    this.setState({ showAddModel: true })
    setTimeout(() => {
      this.setState({ loading: false });
    }, 900);
  }

  onDelete(job) {

    return event => {
      event.preventDefault()
      this.setState({ selectedJob: job }, () => {
        this.setState({ showDeleteModel: true })
      })

      // if(department.users.length > 0) {
      //     this.setState({showAlertModel: true})
      // } else {
      //     axios({
      //         method: 'delete',
      //         url: '/departments/'  + department.id,
      //         headers: {Authorization: `Bearer ${localStorage.getItem('token')}`}
      //     })
      //     .then(res => {
      //         this.setState({completed: true})
      // setTimeout(() => {
      //   this.setState({ loading: false });
      // }, 900);
      //     })
      //     .catch(err => {
      //         this.setState({hasError: true, errorMsg: err.response.data.message})
      // setTimeout(() => {
      //   this.setState({ loading: false });
      // }, 900);
      //     })
      // }

    }
  }

  render() {
    let closeEditModel = () => this.setState({ showEditModel: false })
    let closeAddModel = () => this.setState({ showAddModel: false })
    let closeDeleteModel = () => this.setState({ showDeleteModel: false })

    const baseStyle = {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      fontSize: '0.875rem',
      padding: '3px 9px',
      borderRadius: '20px',
    };
    const getJobBadgeStyle = (type) => {
      switch (type) {
        case 'current':
          return {
            ...baseStyle,
            backgroundColor: '#d1e7dd',
            color: '#0f5132',
            fontSize: '0.75rem',
            fontWeight: 500,
          };
        case 'old':
          return {
            ...baseStyle,
            backgroundColor: '#fff3cd',
            color: '#664d03',
            fontSize: '0.75rem',
            fontWeight: 500,
          };
        case 'future':
          return {
            ...baseStyle,
            backgroundColor: '#cfe2ff',
            color: '#084298',
            fontSize: '0.75rem',
            fontWeight: 500,
          };
        default:
          return baseStyle;
      }
    };

    const theme = createTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: '6px 6px 6px 6px'
          }
        }
      }
    })

    return (
      <CommonLoader isLoading={this.state.loading}>
        <div className="container-fluid pt-4">
          <div className="row">
            <div className="col-sm-12">
              <Card className="shadow-sm rounded">
                <Card.Header style={{ backgroundColor: "#515e73", color: "white" }}>
                  <strong>Select Department</strong>
                </Card.Header>
                <Card.Body>
                  <Row className="mb-3">
                    <Col xs={12} md={4} lg={4}>
                      <Form.Group controlId="departmentSelect">
                        <Form.Label className="text-muted required mb-2 form-label">Department</Form.Label>
                        <Form.Control
                          as="select"
                          value={this.state.selectedDepartment || ''}
                          onChange={this.handleChange}
                          className="form-select"
                        >
                          <option value="">Choose one...</option>
                          {this.pushSelectItems()}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>

                </Card.Body>
              </Card>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className='d-flex search-btn-gap'>
                {
                  hasPermission('M8B3') && (
                    <div className='add-role'>
                      <Button onClick={this.addJob} variant="primary" className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button"> <i className="fa fa-plus-circle"></i> Add Job</Button>
                    </div>
                  )
                }
              </div>
              <Card className="main-card">
                <Card.Header>
                  <div className="panel-title">
                    <strong>Job List</strong>
                  </div>
                </Card.Header>
                <Card.Body>
                  <ThemeProvider theme={theme}>
                    <MaterialTable
                      columns={[
                        { title: 'JOB ID', field: 'id' },
                        { title: 'Job Title', field: 'jobTitle' },
                        { title: 'Employee', field: 'user.fullName' },
                        {
                          title: "Start Date",
                          field: "startDate",
                          render: rowData => DateTimeFormat(rowData.startDate),

                        },
                        {
                          title: " End Date",
                          field: "endDate",
                          render: rowData => {
                            console.log("this is raw data : ", rowData)
                            if (rowData?.endDate == "Invalid date") return "N/A"; // If endDate is null, undefined, or empty, return "N/A"
                            return DateTimeFormat(rowData.endDate);
                          }
                        },
                        {
                          title: 'State',
                          field: 'endDate',
                          render: job => (
                            //We have to set startDate hours to 0 and endDate hours to 24 so that the state of the job remains the same the whole day
                            new Date(job.startDate).setHours(0) > new Date() ? (<Badge variant="warning">Future Job</Badge>) : (
                              new Date(job.endDate).setHours(24) >= new Date() ? (
                                <span style={getJobBadgeStyle('current')}>
                                  < FaCheckCircle /> Current Job
                                </span>
                                // <Badge variant="success">Current Job</Badge>
                              ) : (
                                <span style={getJobBadgeStyle('old')}>
                                  <FaTimesCircle /> Old Job
                                </span>
                                // <Badge variant="danger">Old Job</Badge>
                              )
                            )
                          ),
                          cellStyle: {
                            paddingLeft: 10,
                            paddingRight: 50
                          },
                          headerStyle: {
                            paddingLeft: 30,
                            paddingRight: 50
                          }
                        },
                        {
                          title: 'Action',
                          render: rowData => (
                            <Form className="row justify-content-center">
                              <div className="col-auto address-div">
                                {hasPermission('M8B1') && (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id={`tooltip-edit-${rowData.id}`}>Edit Job</Tooltip>}
                                  >
                                    <Button size="sm" variant="outline-info" className="info" onClick={this.onEdit(rowData)}><i className="fas fa-edit"></i></Button>
                                  </OverlayTrigger>
                                )}

                                {/* <Button size="sm" variant="outline-info" onClick={this.onEdit(rowData)}><i className="fas fa-edit"></i></Button> */}

                                {/* <Button onClick={this.onDelete(rowData)} size="sm" variant="danger"><i className="fas fa-trash"></i></Button> */}
                                {hasPermission('M8B2') && (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id={`tooltip-edit-${rowData.id}`}>Delete Job</Tooltip>}
                                  >
                                    <Button onClick={this.onDelete(rowData)} size="sm" className="delete-btn" variant="outline-danger"><i className="fas fa-trash"></i></Button>
                                  </OverlayTrigger>
                                )}
                              </div>
                            </Form>
                          ),
                          cellStyle: { width: '250px', minWidth: '250px', textAlign: 'center' },
                          headerStyle: { width: '250px', minWidth: '250px', textAlign: 'center' }
                        }
                      ]}
                      data={this.state.jobs}

                      options={{
                        rowStyle: (rowData, index) => {
                          if (index % 2) {
                            return { backgroundColor: '#f2f2f2' }
                          }
                        },
                        pageSize: 10,
                        pageSizeOptions: [5, 10, 20, 30, 50, 75, 100]
                      }}
                      title={this.selectedUser ? this.selectedUser.fullName : ''}
                    />
                  </ThemeProvider>
                </Card.Body>
              </Card>
              {this.state.showEditModel ? (
                <JobEditModal show={true} onHide={closeEditModel} data={this.state.selectedJob}

                />
              ) : this.state.showAddModel ? (
                <JobAddModal show={true} onHide={closeAddModel} />
              ) : this.state.showDeleteModel ? (
                <JobDeleteModal show={true} onHide={closeDeleteModel} data={this.state.selectedJob} />
              ) : (<></>)}
            </div>
          </div>
          {/* {this.state.hasError ? (
            <Alert variant="danger" className="m-3" block>
              {this.state.errMsg}
            </Alert>
          ) : this.state.completed ? (
            <Redirect to="/departments" />
          ) : (<></>)} */}
        </div>
      </CommonLoader >
    );
  }
}